import ImageLightbox from './ImageLightbox';

export default ImageLightbox;
